import React from 'react'

import { cn } from '~/styled'

import { SkeletonLoader } from './Skeleton'

export const SkeletonButton = ({
  className
}: {
  className?: React.ComponentProps<typeof SkeletonLoader>['className']
}) => (
  <SkeletonLoader className={cn('w-[10rem]', 'h-8', 'rounded-sm', className)} />
)
